// "A sign-in / sign-up is in flight" flag shared by the whole app. The loading screen is drawn from here (see
// components/AuthPendingOverlay.tsx) instead of from inside the Auth page, because the app swaps between two different
// Auth screens while a login completes (the embedded one on the Profile tab, then the full-screen one) - state kept
// inside Auth was lost in that swap, which showed the form for a flash.
let pending = false;
let safetyTimer: number | undefined;
const listeners = new Set<() => void>();

export const subscribeAuthPending = (fn: () => void) => { listeners.add(fn); return () => { listeners.delete(fn); }; };
export const getAuthPending = () => pending;

export const setAuthPending = (next: boolean) => {
  if (safetyTimer) { window.clearTimeout(safetyTimer); safetyTimer = undefined; }
  // Safety net only: never keep the form hidden for more than 20s if the app stalls.
  if (next) safetyTimer = window.setTimeout(() => setAuthPending(false), 20000);
  if (pending === next) return;
  pending = next;
  listeners.forEach(fn => fn());
};
